import clsx from 'clsx';
import React, { Fragment, useRef, PropsWithChildren } from 'react';
import { NavItemButton } from './NavItemButton';
import { Popover } from '@headlessui/react';

export interface NavDropdownProps {
  label: string;
  paths: string[];
}

export const NavDropdown = ({ children, label, paths }: PropsWithChildren<NavDropdownProps>) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const handlePopoverPanelClick = () => {
    buttonRef.current!.click();
  };

  return (
    <Popover className='h-full'>
      {({ open }) => (
        <Fragment>
          <Popover.Button ref={buttonRef} className='h-full'>
            <NavItemButton path={paths} isActive={open}>
              {label}
            </NavItemButton>
          </Popover.Button>
          <Popover.Panel
            onClick={handlePopoverPanelClick}
            className={clsx(
              open ? 'block' : 'hidden',
              'border rounded-md divide-y',
              'absolute flex text-base z-40 list-none shadow-lg justify-start flex-col bg-white overflow-hidden'
            )}
          >
            {children}
          </Popover.Panel>
        </Fragment>
      )}
    </Popover>
  );
};
